var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6881 1.42084C17.981 1.12795 18.4559 1.12795 18.7488 1.42084L22.9914 5.66347C23.1321 5.80412 23.2111 5.99489 23.2111 6.1938C23.2111 6.39271 23.1321 6.58348 22.9914 6.72413L7.43508 22.2805C7.29443 22.4211 7.10366 22.5002 6.90474 22.5002L2.66222 22.5001C2.24802 22.5 1.91225 22.1643 1.91224 21.7501L1.91211 17.5075C1.9121 17.3086 1.99112 17.1178 2.13178 16.9772L17.6881 1.42084ZM18.2185 3.01183L3.41212 17.8182L3.41222 21.0001L6.5941 21.0001L21.4004 6.1938L18.2185 3.01183Z",
    fill: "#949589"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4462 5.66303C13.7391 5.37014 14.214 5.37014 14.5069 5.66303L18.7495 9.90568C19.0424 10.1986 19.0424 10.6734 18.7495 10.9663C18.4566 11.2592 17.9818 11.2592 17.6889 10.9663L13.4462 6.72369C13.1533 6.4308 13.1533 5.95592 13.4462 5.66303Z",
    fill: "#949589"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.fb03fe11b58aab2add6c50521ec88bd6.svg";
export { ForwardRef as ReactComponent };